import { useEffect } from 'react';

import { useAuth0 } from '@hooks/useAuth0';
import { useUserQuery } from '@queries/user';
import { monitoring } from '@services/monitoring';

export function Monitoring() {
  // Identify the user when authenticated
  const { isAuthenticated } = useAuth0();
  const { data: user } = useUserQuery({ enabled: isAuthenticated });
  useEffect(() => {
    if (isAuthenticated && user) {
      monitoring.identify(user);
    }
  }, [isAuthenticated, user]);

  return null;
}
